import { render } from "./IngredientList.vue?vue&type=template&id=6c1c40d8&ts=true"
import script from "./IngredientList.vue?vue&type=script&lang=ts"
export * from "./IngredientList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__